import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setSiteName } from 'store/settings/nameSlice'
import { apiGetSiteName, apiUpdateSiteName } from 'services/SettingService'

export const DEFAULT_SITE_NAME = 'Vantix'

// Read-only: just the current value, no fetch side-effect. Use this in
// every component that only needs to display the name.
export function useSiteNameValue() {
    const value = useSelector((state) => state.settings.name.value)
    return value || DEFAULT_SITE_NAME
}

// Fetch-on-mount + read + update. Only call this where the app should
// trigger the initial load (the top-level Layout) or where it needs to
// write a new value (the settingsdb page). Everywhere else, use
// useSiteNameValue() instead, so mounting the same component many times
// doesn't fire the same GET request repeatedly.
function useSiteName() {

    const dispatch = useDispatch()

    const loaded = useSelector((state) => state.settings.name.loaded)
    const siteName = useSiteNameValue()

    useEffect(() => {
        if (loaded) {
            return
        }
        apiGetSiteName().then(resp => {
            dispatch(setSiteName(resp.data.site_name || DEFAULT_SITE_NAME))
        }).catch(() => {})
    }, [loaded, dispatch])

    const updateName = async (name) => {
        const resp = await apiUpdateSiteName(name)
        dispatch(setSiteName(resp.data.site_name))
        return resp.data.site_name
    }

    return { siteName, updateName }
}

export default useSiteName
